import bemBlock from '@gik/core/utils/bemBlock';
import { FrameBone } from '@gik/ui/SkeletonLoader';
import React from 'react';

export default function GiftCardSkeleton() {
  const bem = bemBlock('gift-card-skeleton');
  return <FrameBone className={bem()} />;
}
